import React, { useState, useEffect } from 'react';
import axios from 'axios';
import logo from '../../assets/xpdw.png'; // Adjust the path as necessary
import { MuiTelInput } from 'mui-tel-input';
import Select from 'react-select';
import { countries } from '../../utils/countries';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import * as CountryFlags from 'country-flag-icons/react/3x2';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import { parsePhoneNumber } from 'libphonenumber-js'

import {
    TextField,
    Button,
    Container,
    Typography,
    Box,
    Snackbar,
    Alert,
    // Select,
    MenuItem,
    Grid,
    Link,
    FormControl,
    InputLabel,
    Checkbox, FormControlLabel, FormHelperText,
    Paper, CircularProgress,
    Divider, link, alpha
} from '@mui/material';

// Import icons
import {
    AccountCircle,
    Lock,
    Email,
    Person,
    Phone,
    Flag,
    Home,
    LocationCity,
    Public,
    MarkunreadMailbox,
    AppRegistration,
    AccountBalanceWallet,
    Speed,
    Shield
} from '@mui/icons-material';


const Register = () => {
    // Existing state
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('user');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [open, setOpen] = React.useState(false);
    // / Add these state variables at the top of your component
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [agreements, setAgreements] = useState({
        terms: false,
        bonus: false
    });
    const [agreementErrors, setAgreementErrors] = useState({
        terms: '',
        bonus: ''
    });
    const handleAgreementChange = (event) => {
        const { name, checked } = event.target;
        setAgreements(prev => ({
            ...prev,
            [name]: checked
        }));
        // Clear error when checkbox is checked
        if (checked) {
            setAgreementErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Add these handler functions
    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleToggleConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const [countries, setCountries] = useState([]);


    useEffect(() => {
        fetchCountries();
    }, []);

    const fetchCountries = async () => {
        try {
            const response = await axios.get('/api/api/countriesList');
            if (response.data.status === 'success') {
                const formattedCountries = response.data.data.map(country => ({
                    code: country.iso,     // Using iso as code
                    label: country.name, // Using nicename as label
                    value: country.iso      // Using iso as value
                }));
                setCountries(formattedCountries);
            }
        } catch (error) {
            console.error('Error fetching countries:', error);
            toast.error('Failed to fetch countries');
        }
    };



    const formatOptionLabel = ({ label, code }) => {
        const FlagComponent = CountryFlags[code];
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {FlagComponent && <FlagComponent style={{ width: 24, height: 16 }} />}
                <span>{label}</span>
            </div>
        );
    };
    // New state for additional fields
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        mobileNumber: '',
        gender: '',
        nationality: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        country: '',
        zipCode: '',
        state: ''
    });

    // Add these validation functions at the top of your component
    const validations = {
        hasSpecialCharacters: (value) => /[!@#$%^&*(),.?":{}|<>]/.test(value),
        isOver18: (dateString) => {
            const today = new Date();
            const birthDate = new Date(dateString);
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age >= 18;
        },
        isMobileValid: (number) => /^[0-9]{10}$/.test(number),
        isISOCode: (code) => /^[A-Za-z]{2}$/.test(code),
        // isMobileValid: (phoneNumber) => {
        //     if (!phoneNumber) return false

        //     try {
        //       const parsed = parsePhoneNumberFromString(phoneNumber)
        //       return parsed?.isValid() || false
        //     } catch (err) {
        //       return false
        //     }
        //   },
        isEmailValid: (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
        isPasswordValid: (password) => {
            const minLength = 8;
            const hasUpperCase = /[A-Z]/.test(password);
            const hasLowerCase = /[a-z]/.test(password);
            const hasNumbers = /\d/.test(password);
            const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
            return password.length >= minLength && hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar;
        }
    };
    // Add these to your state
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    // Add password validation handlers
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setUsername(value);

        if (!value) {
            setEmailError('Email is required');
        } else if (!validations.isEmailValid(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);

        if (!value) {
            setPasswordError('Password is required');
        } else if (!validations.isPasswordValid(value)) {
            setPasswordError(
                'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character'
            );
        } else {
            setPasswordError('');
        }

        // Check confirm password match
        if (confirmPassword && value !== confirmPassword) {
            setConfirmPasswordError('Passwords do not match');
        } else {
            setConfirmPasswordError('');
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);

        if (!value) {
            setConfirmPasswordError('Please confirm your password');
        } else if (value !== password) {
            setConfirmPasswordError('Passwords do not match');
        } else {
            setConfirmPasswordError('');
        }
    };
    // Add error state
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        mobileNumber: '',
        nationality: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        country: '',
        zipCode: ''
    });


    // Modify handleInputChange to include validation
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        const expectedLengths = {
            AF: 9, AL: 9, DZ: 9, AS: 10, AD: 6, AO: 9, AI: 10, AG: 10, AR: 10, AM: 8, AW: 7,
            AU: 9, AT: 10, AZ: 9, BS: 10, BH: 8, BD: 10, BB: 10, BY: 9, BE: 9, BZ: 7, BJ: 8,
            BM: 10, BT: 8, BO: 8, BA: 8, BW: 7, BR: 11, IO: 7, BN: 7, BG: 9, BF: 8, BI: 8,
            KH: 9, CM: 9, CA: 10, CV: 7, KY: 10, CF: 8, TD: 8, CL: 9, CN: 11, CO: 10, KM: 7,
            CG: 9, CD: 9, CR: 8, HR: 9, CU: 8, CY: 8, CZ: 9, DK: 8, DJ: 8, DM: 10, DO: 10,
            EC: 9, EG: 10, SV: 8, GQ: 9, ER: 7, EE: 7, SZ: 8, ET: 9, FJ: 7, FI: 10, FR: 9,
            GA: 7, GM: 7, GE: 9, DE: 11, GH: 9, GI: 8, GR: 10, GL: 6, GD: 10, GU: 10, GT: 8,
            GN: 9, GW: 7, GY: 7, HT: 8, HN: 8, HK: 8, HU: 9, IS: 7, IN: 10, ID: 10, IR: 10,
            IQ: 10, IE: 9, IL: 9, IT: 10, JM: 10, JP: 10, JO: 9, KZ: 10, KE: 10, KI: 5,
            KR: 10, KW: 8, KG: 9, LA: 10, LV: 8, LB: 8, LS: 8, LR: 8, LY: 9, LI: 7, LT: 8,
            LU: 9, MO: 8, MG: 9, MW: 9, MY: 9, MV: 7, ML: 8, MT: 8, MH: 7, MQ: 9, MR: 8,
            MU: 7, MX: 10, FM: 7, MD: 8, MC: 9, MN: 8, ME: 8, MA: 9, MZ: 9, MM: 9, NA: 9,
            NP: 10, NL: 9, NZ: 9, NI: 8, NE: 8, NG: 10, NO: 8, OM: 8, PK: 10, PW: 7, PS: 9,
            PA: 8, PG: 7, PY: 9, PE: 9, PH: 10, PL: 9, PT: 9, PR: 10, QA: 8, RE: 9, RO: 10,
            RU: 10, RW: 9, KN: 10, LC: 10, VC: 10, WS: 7, SM: 10, ST: 7, SA: 9, SN: 9, RS: 9,
            SC: 7, SL: 8, SG: 8, SX: 10, SK: 9, SI: 8, SB: 7, SO: 8, ZA: 9, SS: 9, ES: 9,
            LK: 9, SD: 9, SR: 7, SE: 9, CH: 9, SY: 9, TW: 9, TJ: 9, TZ: 9, TH: 9, TG: 8,
            TO: 5, TT: 10, TN: 8, TR: 10, TM: 8, UG: 9, UA: 9, AE: 9, GB: 10, US: 10, UY: 9,
            UZ: 9, VU: 7, VE: 10, VN: 9, YE: 9, ZM: 9, ZW: 9
        }
        if (name === 'mobileNumber') {
            try {
                const parsed = parsePhoneNumber(value);

                if (parsed && parsed.isValid()) {
                    const country = parsed.country;
                    const nationalNumberLength = parsed.nationalNumber.length;
                    const expectedLength = expectedLengths[country];

                    // Only update form data if within length limits or backspacing
                    if (!expectedLength || nationalNumberLength <= expectedLength) {
                        setFormData(prev => ({
                            ...prev,
                            [name]: value
                        }));
                    }

                    // Set appropriate error message
                    if (!expectedLength) {
                        setErrors(prev => ({
                            ...prev,
                            mobileNumber: 'Unknown country format'
                        }));
                    } else if (nationalNumberLength > expectedLength) {
                        setErrors(prev => ({
                            ...prev,
                            mobileNumber: `Phone number must be ${expectedLength} digits for ${country}`
                        }));
                    } else if (nationalNumberLength < expectedLength) {
                        setErrors(prev => ({
                            ...prev,
                            mobileNumber: `Please enter ${expectedLength} digits (${nationalNumberLength}/${expectedLength})`
                        }));
                    } else {
                        setErrors(prev => ({
                            ...prev,
                            mobileNumber: ''
                        }));
                    }
                } else {
                    setFormData(prev => ({
                        ...prev,
                        [name]: value
                    }));
                    setErrors(prev => ({
                        ...prev,
                        mobileNumber: 'Invalid phone number'
                    }));
                }
            } catch (err) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value
                }));
                setErrors(prev => ({
                    ...prev,
                    mobileNumber: 'Invalid phone number format'
                }));
            }
            return; // Exit early for mobile number handling
        }
        // Validation logic
        let error = '';
        if (name === 'firstName' || name === 'lastName') {
            const nameRegex = /^[a-zA-Z\s]*$/; // Only allows alphabets and spaces for names
            if (!nameRegex.test(value)) {
                error = 'Only alphabets and spaces are allowed';
            } else if (value.length > 40) {
                error = 'Maximum 40 characters allowed';
            }
        } else if (name === 'city' || name === 'state' || name === 'zipCode') {
            const addressRegex = /^[a-zA-Z0-9\s]*$/; // Allows numbers, alphabets, and spaces
            if (!addressRegex.test(value)) {
                error = 'Only numbers, alphabets, and spaces are allowed';
            } else if (value.length > 40) {
                error = 'Maximum 40 characters allowed';
            }
        } else if (name === 'addressLine1' || name === 'addressLine2') {
            const addressRegex = /^[a-zA-Z0-9\s]*$/; // Allows numbers, alphabets, and spaces
            if (!addressRegex.test(value)) {
                error = 'Only numbers, alphabets, and spaces are allowed';
            } else if (value.length > 100) {
                error = 'Maximum 100 characters allowed';
            }
        } else if (validations.hasSpecialCharacters(value)) {
            error = 'Special characters are not allowed';
        } else {
            switch (name) {
                case 'firstName':
                case 'lastName':
                    if (value.length > 40) error = 'Maximum 40 characters allowed';
                    break;
                case 'dateOfBirth':
                    if (!validations.isOver18(value)) error = 'Must be 18 years or older';
                    break;
                // case 'mobileNumber':
                //     if (!validations.isMobileValid(value)) error = 'Invalid mobile number for selected country';
                //     break;
                // case 'mobileNumber':
                //     if (!validations.isMobileValid(value)) error = 'Must be 10 digits';
                //     break;
                case 'nationality':
                case 'country':
                    if (!validations.isISOCode(value)) error = 'Must be 2 letter ISO code';
                    break;
                case 'addressLine1':
                case 'addressLine2':
                    if (value.length > 40) error = 'Maximum 40 characters allowed';
                    break;
                case 'city':
                    if (value.length > 20) error = 'Maximum 20 characters allowed';
                    break;
                case 'state':
                    if (value.length > 10) error = 'Maximum 10 characters allowed';
                    break;
                case 'zipCode':
                    if (value.length > 10) error = 'Maximum 10 characters allowed';
                    break;


            }
        }

        setErrors(prev => ({ 
            ...prev,
            [name]: error
        }));
    };

    // Existing handlers remain the same
    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        setOpen(false);
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    // const formatOptionLabel = ({ label, code }) => (
    //     <div style={{ display: 'flex', alignItems: 'center' }}>
    //         {CountryFlags[code.toUpperCase()] && React.createElement(CountryFlags[code.toUpperCase()], {
    //             style: { width: '20px', marginRight: '8px' }
    //         })}
    //         <span>{label}</span>
    //     </div>
    // );
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Age validation
        const age = calculateAge(formData.dateOfBirth);
        if (age < 18) {
            toast.error('You must be 18 or older to register');
            return;
        }

        if (password !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        // Validate agreements
        const newAgreementErrors = {};
        if (!agreements.terms) {
            newAgreementErrors.terms = 'You must accept the Terms and Conditions';
        }
        if (!agreements.bonus) {
            newAgreementErrors.bonus = 'You must accept the Bonus Policy';
        }

        if (Object.keys(newAgreementErrors).length > 0) {
            setAgreementErrors(newAgreementErrors);
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const response = await axios.post('/api/register', {
                username,
                password,
                confirmPassword,
                ...formData
            });

            // Handle successful registration (201 Created)
            if (response.status === 201) {
                // Create a promise that resolves after 5 seconds
                const redirectPromise = new Promise((resolve) => {
                    let countdown = 5;

                    const timer = setInterval(() => {
                        countdown--;
                        if (countdown === 0) {
                            clearInterval(timer);
                            resolve();
                        }
                        // Update the toast message
                        toast.loading(
                            `Registration successful! Redirecting in ${countdown} seconds...`,
                            { id: 'registerToast' }
                        );
                    }, 1000);
                });

                // Show initial success message
                toast.loading('Registration successful! Redirecting in 5 seconds...',
                    { id: 'registerToast' }
                );

                // Wait for the countdown to complete
                await redirectPromise;
 
                // Show final success message
                toast.success('Redirecting...', {
                    id: 'registerToast',
                    duration: 1000
                });

                // Redirect after the final toast
                setTimeout(() => {
                    navigate('/login');
                }, 1000);
            }

        } catch (error) {
            const statusCode = error.response?.status;
            const errorMessage = error.response?.data?.message || error.response?.data?.error || 'Please try again';

            switch (statusCode) {
                case 400:
                    // Check if the error is related to duplicate email
                    if (errorMessage.toLowerCase().includes('username') &&
                        (errorMessage.toLowerCase().includes('exists') ||
                            errorMessage.toLowerCase().includes('already') ||
                            errorMessage.toLowerCase().includes('taken'))) {
                        toast.error('This username is already registered. Please use a different email or try logging in.', {
                            duration: 4000
                        });
                    } else {
                        // Other validation errors
                        toast.error(`Validation Error: ${errorMessage}`, {
                            duration: 4000
                        });
                    }
                    break;

                case 500:
                    // Internal Server Error
                    toast.error('Server Error: Something went wrong on our end. Please try again later.', {
                        duration: 4000
                    });
                    break;

                default:
                    // Handle any other errors
                    toast.error(`Registration failed: ${errorMessage}`, {
                        duration: 4000
                    });
            }
        }
        finally {
            setIsSubmitting(false);
        }
    };

    //Gender options
    const genderOptions = [
        { value: 'M', label: 'Male' },
        { value: 'F', label: 'Female' },
        // { value: 'Other', label: 'Other' },
    ];
    // Age calculation helper
    const calculateAge = (birthDate) => {
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    };

    // Theme configuration
    const formTheme = {
        paper: {
            background: '#ffffff',
            borderRadius: 2,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            padding: '24px'
        },
        title: {
            color: '#000000',
            fontWeight: 600,
            fontSize: '1.1rem'
        },
        divider: {
            background: '#000000',
            opacity: 0.1
        },
        inputField: {
            '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                    borderColor: '#000000',
                },
            }
        }
    };

    return (

        <>


            <Container maxWidth="xxl">
                <Grid container spacing={{ xs: 2, md: 4 }} columns={12}>
                    <Grid item
                        xs={12}
                        md={5}
                        sx={{
                            display: {
                                xs: 'none', // Hidden on mobile
                                sm: 'none', // Hidden on tablet
                                md: 'block' // Visible on desktop
                            }
                        }}>
                        <Box
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                position: 'sticky',
                                top: 0,
                                p: 3
                            }}
                        >
                            <Paper
                                elevation={0}
                                sx={{
                                    background: 'linear-gradient(45deg, #000000, #1a1a1a)',
                                    borderRadius: '20px',
                                    p: 4,
                                    height: '97vh',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}
                            >
                                {/* Animated Background Elements */}
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        opacity: 0.1,
                                        background: ``,
                                    }}
                                />

                                {/* Logo and Title Section */}
                                <Box sx={{
                                    position: 'relative', mb: 6, display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: {
                                        xs: '80px',    // Height for extra-small screens
                                        sm: '100px',   // Height for small screens
                                        md: '120px'    // Height for medium screens
                                    }
                                }}>
                                    <img
                                        src={logo}
                                        alt="XPD Logo"
                                        style={{
                                            width: '20%',
                                            height: 'auto',
                                            objectFit: 'contain',
                                            filter: 'drop-shadow(0px 4px 8px rgba(84, 35, 116, 0.15))'
                                        }}
                                    />
                                </Box>

                                {/* Features Section */}
                                <Box sx={{ position: 'relative', mb: 6 }}>
                                    <Grid container spacing={3}>
                                        {[
                                            {
                                                icon: <AccountBalanceWallet sx={{ fontSize: 40 }} />,
                                                title: 'Secure Wallet',
                                                desc: 'Multi-layer security protection'
                                            },
                                            {
                                                icon: <Speed sx={{ fontSize: 40 }} />,
                                                title: 'Instant Transfers',
                                                desc: 'Lightning-fast transactions'
                                            },
                                            {
                                                icon: <Shield sx={{ fontSize: 40 }} />,
                                                title: 'Safe & Encrypted',
                                                desc: 'End-to-end encryption'
                                            }
                                        ].map((feature, index) => (
                                            <Grid item xs={12} key={index}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: 2,
                                                        bgcolor: 'rgba(255, 255, 255, 0.05)',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            bgcolor: 'rgba(255, 255, 255, 0.1)',
                                                        }
                                                    }}
                                                >
                                                    <Box sx={{ color: '#ffffff', mr: 2 }}>
                                                        {feature.icon}
                                                    </Box>
                                                    <Box>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                color: '#ffffff',
                                                                fontWeight: 600,
                                                                mb: 0.5
                                                            }}
                                                        >
                                                            {feature.title}
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: 'rgba(255, 255, 255, 0.7)'
                                                            }}
                                                        >
                                                            {feature.desc}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>

                                {/* Bottom Stats Section */}
                                <Box
                                    sx={{
                                        position: 'relative',
                                        pt: 3,
                                        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                                        textAlign: 'center'
                                    }}
                                >
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontWeight: 700,
                                            lineHeight: 1.2,
                                            position: 'relative',
                                            display: 'inline-block',
                                            '& .highlight': {
                                                background: `linear-gradient(45deg, #542374, #7b3aa0)`,
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                display: 'block',
                                                fontSize: '0.8em',
                                                fontWeight: 300,
                                                letterSpacing: '4px',
                                                marginBottom: '8px'
                                            },
                                            '& .main': {
                                                color: '#ffffff',
                                                display: 'block',
                                                letterSpacing: '1px',
                                                marginBottom: '1rem'
                                            }
                                        }}
                                    >
                                        {/* <span className="highlight">START YOUR JOURNEY</span> */}
                                        <span className="main">Join Our Platform</span>
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 2,
                                            mt: 2
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: 'rgba(255, 255, 255, 0.9)',
                                                fontWeight: 500,
                                                fontSize: '1.1rem'
                                            }}
                                        >
                                            Register Now
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                animation: 'moveRight 1.5s infinite',
                                                '@keyframes moveRight': {
                                                    '0%': {
                                                        transform: 'translateX(0)'
                                                    },
                                                    '50%': {
                                                        transform: 'translateX(10px)'
                                                    },
                                                    '100%': {
                                                        transform: 'translateX(0)'
                                                    }
                                                }
                                            }}
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M14 5L21 12M21 12L14 19M21 12H3"
                                                    stroke="#7b3aa0"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </Box>
                                    </Box>


                                    <Box
                                        sx={{
                                            mt: 3,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            gap: 3
                                        }}
                                    >
                                        {['Instant Access', 'Secure Platform', '24/7 Support'].map((item, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 6,
                                                        height: 6,
                                                        borderRadius: '50%',
                                                        bgcolor: '#7b3aa0'
                                                    }}
                                                />
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: 'rgba(255, 255, 255, 0.8)',
                                                        fontSize: '0.8rem'
                                                    }}
                                                >
                                                    {item}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>



                            </Paper>
                        </Box>
                    </Grid>


                    <Grid
                        item
                        md={1}
                        sx={{
                            display: {
                                xs: 'none',
                                sm: 'none',
                                md: 'block'
                            }
                        }}
                    />
                    <Grid item
                        xs={12}
                        sm={12}
                        md={5}
                        sx={{
                            width: '100%',
                            px: { xs: 2, sm: 3, md: 0 }
                        }}>
                        <Box
                            sx={{
                                mb: { xs: 2, sm: 3, md: 4 },
                                mt: { xs: 2, sm: 2, md: 3 }
                            }}
                        >
                            <Typography
                                variant="h3"
                                component="h1"
                                sx={{
                                    fontWeight: 300,
                                    color: '#000000',
                                    mb: 2,
                                    borderLeft: '4px solid #000000',
                                    pl: 2,
                                    fontSize: {
                                        xs: '1.75rem',
                                        sm: '2.25rem',
                                        md: '3rem'
                                    }
                                }}
                            >
                                Registration
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: 'text.secondary',
                                    pl: 3
                                }}
                            >
                                Welcome! Please complete the registration form below
                            </Typography>
                        </Box>

                        <Box sx={{
                            mt: { xs: 2, sm: 3, md: 4 },
                            mb: { xs: 2, sm: 3, md: 4 }
                        }}>
                            <form onSubmit={handleSubmit}>
                                <Paper elevation={0} sx={{ ...formTheme.paper, mb: 3, p: { xs: 2, sm: 3 } }}>
                                    <Typography variant="h6" gutterBottom sx={{
                                        ...formTheme.title,
                                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                                    }}>
                                        Account Credentials
                                    </Typography>
                                    <Divider sx={{ ...formTheme.divider, mb: 3 }} />
                                    <Grid container spacing={{ xs: 2, sm: 3 }}>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="Email"
                                                variant="outlined"
                                                type="email"
                                                fullWidth
                                                value={username}
                                                onChange={handleEmailChange}
                                                required
                                                error={!!emailError}
                                                helperText={emailError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Email sx={{
                                                            mr: 1,
                                                            color: emailError ? 'error.main' : 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }

                                                        }} />
                                                    )
                                                }}
                                                sx={{
                                                    ...formTheme.inputField,
                                                    '& .MuiInputBase-root': {
                                                        fontSize: { xs: '0.875rem', sm: '1rem' }
                                                    },
                                                    // Add these styles to remove browser's default eye icon
                                                    '& input::-ms-reveal': {
                                                        display: 'none',
                                                    },
                                                    '& input::-ms-clear': {
                                                        display: 'none',
                                                    },
                                                    '& input[type="password"]::-webkit-contacts-auto-fill-button': {
                                                        display: 'none !important',
                                                    },
                                                    '& input[type="password"]::-webkit-credentials-auto-fill-button': {
                                                        display: 'none !important',
                                                        visibility: 'hidden',
                                                        pointerEvents: 'none',
                                                        position: 'absolute',
                                                    },
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                variant="outlined"
                                                fullWidth
                                                value={password}
                                                onChange={handlePasswordChange}
                                                required
                                                error={!!passwordError}
                                                helperText={passwordError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Lock sx={{
                                                            mr: 1,
                                                            color: passwordError ? 'error.main' : 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    ),
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleTogglePassword}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    sx: {
                                                        '&::-ms-reveal': {
                                                            display: 'none'
                                                        },
                                                        '&::-ms-clear': {
                                                            display: 'none'
                                                        },
                                                        // Add these styles to remove browser's default eye icon
                                                        '& input::-ms-reveal': {
                                                            display: 'none',
                                                        },
                                                        '& input::-ms-clear': {
                                                            display: 'none',
                                                        },
                                                        '& input[type="password"]::-webkit-contacts-auto-fill-button': {
                                                            display: 'none !important',
                                                        },
                                                        '& input[type="password"]::-webkit-credentials-auto-fill-button': {
                                                            display: 'none !important',
                                                            visibility: 'hidden',
                                                            pointerEvents: 'none',
                                                            position: 'absolute',
                                                        },
                                                    }
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Confirm Password"
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                variant="outlined"
                                                fullWidth
                                                value={confirmPassword}
                                                onChange={handleConfirmPasswordChange}
                                                required
                                                error={!!confirmPasswordError}
                                                helperText={confirmPasswordError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Lock sx={{
                                                            mr: 1,
                                                            color: confirmPasswordError ? 'error.main' : 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    ),
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle confirm password visibility"
                                                                onClick={handleToggleConfirmPassword}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    sx: {
                                                        '&::-ms-reveal': {
                                                            display: 'none'
                                                        },
                                                        '&::-ms-clear': {
                                                            display: 'none'
                                                        }
                                                    }
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <Paper elevation={0} sx={{
                                    ...formTheme.paper,
                                    mb: 3,
                                    p: { xs: 2, sm: 3 }
                                }}>
                                    <Typography variant="h6" gutterBottom sx={{
                                        ...formTheme.title,
                                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                                    }}>
                                        Personal Information
                                    </Typography>
                                    <Divider sx={{ ...formTheme.divider, mb: 3 }} />
                                    <Grid container spacing={{ xs: 2, sm: 3 }}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="firstName"
                                                label="First Name"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.firstName}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.firstName}
                                                helperText={errors.firstName}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Person sx={{
                                                            mr: 1,
                                                            color: 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    )
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="lastName"
                                                label="Last Name"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.lastName}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.lastName}
                                                helperText={errors.lastName}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Person sx={{
                                                            mr: 1,
                                                            color: 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    )
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="dateOfBirth"
                                                label="Date of Birth"
                                                type="date"
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                value={formData.dateOfBirth}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.dateOfBirth}
                                                helperText={errors.dateOfBirth}
                                                size="small"
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontSize: { xs: '0.875rem', sm: '1rem' }
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Select
                                                name="gender"
                                                options={genderOptions}
                                                value={genderOptions.find((g) => g.value === formData.gender)}
                                                onChange={(selected) =>
                                                    handleInputChange({
                                                        target: { name: 'gender', value: selected.value },
                                                    })
                                                }
                                                required
                                                placeholder="Select gender"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        height: 40,
                                                        minHeight: 40,
                                                        fontSize: '0.875rem',
                                                        '@media (min-width: 600px)': {
                                                            fontSize: '1rem',
                                                        }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '0.875rem',
                                                        '@media (min-width: 600px)': {
                                                            fontSize: '1rem',
                                                        }
                                                    })
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <MuiTelInput
                                                label="Mobile Number"
                                                defaultCountry="IN" // change based on your default country
                                                value={formData.mobileNumber}
                                                onChange={(value) => handleInputChange({ target: { name: 'mobileNumber', value } })}
                                                fullWidth
                                                size="small"
                                                required
                                                error={!!errors.mobileNumber}
                                                helperText={errors.mobileNumber}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Select
                                                name="nationality"
                                                options={countries}
                                                value={countries.find((c) => c.code === formData.nationality)}
                                                onChange={(selected) =>
                                                    handleInputChange({
                                                        target: { name: 'nationality', value: selected?.value || '' }
                                                    })
                                                }
                                                required
                                                isSearchable
                                                isClearable
                                                formatOptionLabel={formatOptionLabel}
                                                placeholder="Select nationality"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        height: 40,
                                                        minHeight: 40,
                                                        fontSize: '0.875rem',
                                                        '@media (min-width: 600px)': {
                                                            fontSize: '1rem',
                                                        }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '0.875rem',
                                                        '@media (min-width: 600px)': {
                                                            fontSize: '1rem',
                                                        }
                                                    }),
                                                    option: (base) => ({
                                                        ...base,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '8px 12px',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    })
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <Paper elevation={0} sx={{
                                    ...formTheme.paper, mb: 3,
                                    p: { xs: 2, sm: 3 }
                                }}>
                                    <Typography variant="h6" gutterBottom sx={{
                                        ...formTheme.title,
                                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                                    }}>

                                        Residence Address
                                    </Typography>
                                    <Divider sx={{ ...formTheme.divider, mb: 3 }} />
                                    <Grid container spacing={{ xs: 2, sm: 3 }}>
                                        <Grid item xs={12}>
                                            <TextField
                                                name="addressLine1"
                                                label="Address Line 1"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.addressLine1}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.addressLine1}
                                                helperText={errors.addressLine1}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Home sx={{
                                                            mr: 1,
                                                            color: 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    )
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                name="addressLine2"
                                                label="Address Line 2"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.addressLine2}
                                                onChange={handleInputChange}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Home sx={{
                                                            mr: 1,
                                                            color: 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    )
                                                }}
                                                error={!!errors.addressLine2}
                                                helperText={errors.addressLine2}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                name="city"
                                                label="City"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.city}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.city}
                                                helperText={errors.city}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Home sx={{
                                                            mr: 1,
                                                            color: 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    )
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                name="state"
                                                label="State"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.state}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.state}
                                                helperText={errors.state}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Home sx={{
                                                            mr: 1,
                                                            color: 'action.active',
                                                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                                                        }} />
                                                    )
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        {/* <Grid item xs={6}>
                                        <TextField
                                            name="country"
                                            label="Country (ISO)"
                                            variant="outlined"
                                            fullWidth
                                            value={formData.country}
                                            onChange={handleInputChange}
                                            required
                                            error={!!errors.country}
                                            helperText={errors.country}
                                            InputProps={{
                                                startAdornment: <Public sx={{ mr: 1, color: 'action.active' }} />,
                                                style: { textTransform: 'uppercase' }
                                            }}
                                            size="small"
                                        />
                                    </Grid> */}
                                        <Grid item xs={6}>
                                            <Select
                                                name="country"
                                                options={countries}
                                                value={countries.find((c) => c.code === formData.country)}
                                                onChange={(selected) =>
                                                    handleInputChange({
                                                        target: { name: 'country', value: selected?.value || '' }
                                                    })
                                                }
                                                required
                                                isSearchable
                                                isClearable
                                                formatOptionLabel={formatOptionLabel}
                                                placeholder="Select country"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        height: 40,
                                                        minHeight: 40,
                                                        fontSize: '0.875rem',
                                                        '@media (min-width: 600px)': {
                                                            fontSize: '1rem',
                                                        }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '0.875rem',
                                                        '@media (min-width: 600px)': {
                                                            fontSize: '1rem',
                                                        }
                                                    }),
                                                    option: (base) => ({
                                                        ...base,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '8px 12px',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    })
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                name="zipCode"
                                                label="Zip Code"
                                                variant="outlined"
                                                fullWidth
                                                value={formData.zipCode}
                                                onChange={handleInputChange}
                                                required
                                                error={!!errors.zipCode}
                                                helperText={errors.zipCode}
                                                InputProps={{
                                                    startAdornment: <MarkunreadMailbox sx={{ mr: 1, color: 'action.active' }} />
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        {/* <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="terms"
                                                        checked={agreements.terms}
                                                        onChange={handleAgreementChange}
                                                        color="primary"
                                                    />
                                                }
                                                label={
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Typography variant="body2">
                                                            I accept the{' '}
                                                            <Link
                                                                href="/terms"
                                                                target="_blank"
                                                                sx={{
                                                                    color: '#542374',
                                                                    textDecoration: 'none',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline'
                                                                    }
                                                                }}
                                                            >
                                                                Terms and Conditions
                                                            </Link>
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                            {agreementErrors.terms && (
                                                <FormHelperText error>
                                                    {agreementErrors.terms}
                                                </FormHelperText>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="bonus"
                                                        checked={agreements.bonus}
                                                        onChange={handleAgreementChange}
                                                        color="primary"
                                                    />
                                                }
                                                label={
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Typography variant="body2">
                                                            I accept the{' '}
                                                            <Link
                                                                href="/bonus-policy"
                                                                target="_blank"
                                                                sx={{
                                                                    color: '#542374',
                                                                    textDecoration: 'none',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline'
                                                                    }
                                                                }}
                                                            >
                                                                Bonus Policy
                                                            </Link>
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                            {agreementErrors.bonus && (
                                                <FormHelperText error>
                                                    {agreementErrors.bonus}
                                                </FormHelperText>
                                            )}
                                        </Grid> */}
                                    </Grid>
                                    <Grid container spacing={0.5}>  {/* Reduced spacing between grid items */}
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                sx={{
                                                    margin: 0,  // Remove default margin
                                                    mt: 2,  // Add margin-top for spacing
                                                    '& .MuiFormControlLabel-label': {
                                                        fontSize: {
                                                            xs: '0.8rem',  // Smaller font on mobile
                                                            sm: '0.875rem'  // Regular size on larger screens
                                                        }
                                                    }
                                                }}
                                                control={
                                                    <Checkbox
                                                        name="terms"
                                                        checked={agreements.terms}
                                                        onChange={handleAgreementChange}
                                                        color="primary"
                                                        size="small"  // Smaller checkbox
                                                        sx={{
                                                            padding: '4px',  // Reduced padding
                                                            marginRight: '4px'  // Reduced margin
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        minHeight: '24px'  // Ensure consistent height
                                                    }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize: 'inherit',
                                                                lineHeight: 1.2  // Reduced line height
                                                            }}
                                                        >
                                                            I accept the{' '}
                                                            <Link
                                                                href="https://myxpd.app/terms-of-use"
                                                                target="_blank"
                                                                sx={{
                                                                    color: '#542374',
                                                                    textDecoration: 'none',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline'
                                                                    }
                                                                }}
                                                            >
                                                                Terms and Conditions.
                                                            </Link>
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                            {agreementErrors.terms && (
                                                <FormHelperText
                                                    error
                                                    sx={{
                                                        margin: '0 0 4px 4px',  // Reduced margin
                                                        fontSize: {
                                                            xs: '0.7rem',
                                                            sm: '0.75rem'
                                                        }
                                                    }}
                                                >
                                                    {agreementErrors.terms}
                                                </FormHelperText>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                sx={{
                                                    margin: 0,
                                                    '& .MuiFormControlLabel-label': {
                                                        fontSize: {
                                                            xs: '0.8rem',
                                                            sm: '0.875rem'
                                                        }
                                                    }
                                                }}
                                                control={
                                                    <Checkbox
                                                        name="bonus"
                                                        checked={agreements.bonus}
                                                        onChange={handleAgreementChange}
                                                        color="primary"
                                                        size="small"
                                                        sx={{
                                                            padding: '4px',
                                                            marginRight: '4px'
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        minHeight: '24px'
                                                    }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize: 'inherit',
                                                                lineHeight: 1.2
                                                            }}
                                                        >
                                                            I accept the{' '}
                                                            <Link
                                                                href="/bonus-policy"
                                                                target="_blank"
                                                                sx={{
                                                                    color: '#542374',
                                                                    textDecoration: 'none',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline'
                                                                    }
                                                                }}
                                                            >
                                                                Bonus Policy.
                                                            </Link>
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                            {agreementErrors.bonus && (
                                                <FormHelperText
                                                    error
                                                    sx={{
                                                        margin: '0 0 4px 4px',
                                                        fontSize: {
                                                            xs: '0.7rem',
                                                            sm: '0.75rem'
                                                        }
                                                    }}
                                                >
                                                    {agreementErrors.bonus}
                                                </FormHelperText>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    disabled={isSubmitting}
                                    sx={{
                                        mt: { xs: 2, sm: 3 },
                                        p: { xs: '10px', sm: '12px' },
                                        fontSize: { xs: '0.875rem', sm: '1rem' },
                                        bgcolor: '#000000',
                                        '&:hover': {
                                            bgcolor: '#333333'
                                        },
                                        '&.Mui-disabled': {
                                            bgcolor: 'rgba(0, 0, 0, 0.7)',
                                            color: 'rgba(255, 255, 255, 0.8)'
                                        },
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <CircularProgress
                                                size={16}
                                                sx={{
                                                    color: 'white',
                                                    '@media (min-width: 600px)': {
                                                        size: 20
                                                    }
                                                }}
                                            />
                                            <span>Registering...</span>
                                        </>
                                    ) : (
                                        'Register'
                                    )}
                                </Button>
                                <Box
                                    sx={{
                                        mt: 2,
                                        textAlign: 'center',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 1
                                    }}
                                >
                                    <Typography variant="body2" color="text.secondary">
                                        Already registered?
                                    </Typography>
                                    <Link
                                        href="/login"
                                        // component={RouterLink}
                                        sx={{
                                            textDecoration: 'none',
                                            color: '#542374',
                                            '&:hover': {
                                                textDecoration: 'underline'
                                            },
                                            fontWeight: 500
                                        }}
                                    >
                                        Login
                                    </Link>
                                </Box>
                            </form>
                        </Box>
                    </Grid>
                </Grid>
            </Container >
        </>

    );
};


export default Register;

